<template>
    <div>
        <el-breadcrumb separator="/" class="bread">
            <!--<el-breadcrumb-item :to="{ name: 'index' }">首页</el-breadcrumb-item>-->
            <el-breadcrumb-item>订单管理</el-breadcrumb-item>
        </el-breadcrumb>
        <!-- 操作-->

        <!--工具条-->
        <!--<el-col :span="24" class="toolbar" style="padding: 20px 0px;text-align: left">-->
            <el-form :inline="true" :model="topForm" ref="topForm">

                <el-select v-model="topForm.kioskNo" placeholder="机器编号" @change="time()">
                    <el-option label="全部售货机" value="">全部售货机</el-option>
                    <el-option
                            v-for="(item,index) in kioskList"
                            :label="item.deviceName"
                            :value="item.deviceId"
                    >
                    </el-option>
                </el-select>


                <el-form-item  class="m-1">
                    <el-input v-model="topForm.orderId" placeholder="订单编号" ></el-input>
                </el-form-item>


                <el-date-picker
                        @change="time()"
                        style="width: auto"
                        class="m-1"
                        v-model="topForm.datatime"
                        type="datetimerange"
                        align="right"
                        :clearable=false
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        :default-time="['00:00:00', '23:59:59']">
                </el-date-picker>


                <el-form-item>
                    <el-button type="primary" class="" @click="getData()" icon="search":loading="loading">查询</el-button>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="resetForm('topForm')">重置</el-button>
                </el-form-item>
                </el-form>
            <!--</el-col>-->




        <!-- 表格分页-->
        <div class="block">
            <el-tabs v-model="activeName" @tab-click="handleClick">
                <!-- ----------------------全部------------------ -->
                <el-tab-pane label="全部" name="all">
                    <table-order
                            ref="myOrderall"
                            :orderId="topForm.orderId"
                            :orderstatus="'0'"
                            :kioskNo="topForm.kioskNo"
                            :startTime="topForm.datatime[0].getTime()/1000"
                            :endTime="topForm.datatime[1].getTime()/1000"
                    >
                    </table-order>
                </el-tab-pane>

                <el-tab-pane label="待付款" name="second">
                    <table-order
                            ref="myOrdersecond"
                            :orderId="topForm.orderId"
                            :orderstatus="'2'"
                            :kioskNo="topForm.kioskNo"
                            :startTime="topForm.datatime[0].getTime()/1000"
                            :endTime="topForm.datatime[1].getTime()/1000"
                    >
                    </table-order>
                </el-tab-pane>
                <el-tab-pane label="待取货" name="third">
                    <table-order
                            ref="myOrderthird"
                            :orderId="topForm.orderId"
                            :orderstatus="'3'"
                            :kioskNo="topForm.kioskNo"
                            :startTime="topForm.datatime[0].getTime()/1000"
                            :endTime="topForm.datatime[1].getTime()/1000"
                    >
                    </table-order>
                </el-tab-pane>
                <el-tab-pane label="申请退款" name="sqRef">
                    <table-order
                            ref="myOrdersqRef"
                            :orderId="topForm.orderId"
                            :orderstatus="'7'"
                            :kioskNo="topForm.kioskNo"
                            :startTime="topForm.datatime[0].getTime()/1000"
                            :endTime="topForm.datatime[1].getTime()/1000"
                    >
                    </table-order>
                </el-tab-pane>
                <el-tab-pane label="退款中" name="fourth">
                    <table-order
                            ref="myOrderfourth"
                            :orderId="topForm.orderId"
                            :orderstatus="'4'"
                            :kioskNo="topForm.kioskNo"
                            :startTime="topForm.datatime[0].getTime()/1000"
                            :endTime="topForm.datatime[1].getTime()/1000"
                    >
                    </table-order>
                </el-tab-pane>
                <el-tab-pane label="已完成" name="ok">
                    <table-order
                            ref="myOrderok"
                            :orderId="topForm.orderId"
                            :orderstatus="'5'"
                            :kioskNo="topForm.kioskNo"
                            :startTime="topForm.datatime[0].getTime()/1000"
                            :endTime="topForm.datatime[1].getTime()/1000"
                    >
                    </table-order>
                </el-tab-pane>
                <el-tab-pane label="已关闭" name="close">
                    <table-order
                            ref="myOrderclose"
                            :orderId="topForm.orderId"
                            :orderstatus="'6'"
                            :kioskNo="topForm.kioskNo"
                            :startTime="topForm.datatime[0].getTime()/1000"
                            :endTime="topForm.datatime[1].getTime()/1000"
                    >
                    </table-order>
                </el-tab-pane>
            </el-tabs>
        </div>
    </div>



</template>
<script>
    /*import  Bootpage from "../page/Bootpage.vue"*/
    import moment  from 'moment';
    import tableOrder from './table.vue';
    import ElDialog from "../../../../node_modules/element-ui/packages/dialog/src/component.vue";
    export  default{
        components: {ElDialog,'table-order':tableOrder},
        data(){
            return {
                activeName: 'all',
                /*弹窗选择*/
                refProductVisible: false,
                name:'',
                loading:false,
                kioskList:[],
                refForm:{
                    price:'',
                    orderNo:''
                },
                /*弹窗内容选择*/
                topForm:{
                    orderId:'',
                    kioskNo:'',
                    orderstatus:'',
                    datatime:[new Date(new Date(new Date().toLocaleDateString()).getTime() - 6 * 24 * 60 * 60 * 1000), new Date(new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1)],
                },
                isorno:false,
            }

        },
        created(){
            this.kioskLists();
            this.topForm.orderId = this.$route.query.orderId == undefined ? '' : this.$route.query.orderId;
            this.topForm.datatime = this.$route.query.datatime == undefined ? [new Date(new Date(new Date().toLocaleDateString()).getTime() - 6 * 24 * 60 * 60 * 1000), new Date(new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1)]
                : [new Date(this.$route.query.datatime[0]*1000), new Date(this.$route.query.datatime[1]*1000)];
        },
        methods: {
            time(){
                setTimeout(() =>{
                    this.getData();
                },1000);

            },
            resetForm(formName) {
                this.topForm.datatime = [new Date(new Date(new Date().toLocaleDateString()).getTime() - 6 * 24 * 60 * 60 * 1000), new Date(new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1)];
                this.topForm.orderId = '';
                this.topForm.kioskNo = '';
                this.time();

            },
            /**--------------------------------------end--------------------------------------------------------**/
            handleClose(done) {
                this.$confirm('确认关闭？')
                    .then(_ => {
                        done();
                    })
                    .catch(_ => {});
            },
            getData(){
                this.$refs.myOrderall.getData(0);
                this.$refs.myOrdersecond.getData(0);
                this.$refs.myOrderthird.getData(0);
                this.$refs.myOrdersqRef.getData(0);
                this.$refs.myOrderfourth.getData(0);
                this.$refs.myOrderok.getData(0);
                this.$refs.myOrderclose.getData(0);
                this.handleClick();
            },
            handleClick(tab, event) {
                console.log(tab, event);
            },
            kioskLists(){
                //数据请求
                var params = {orgIds:'6P86B3U8',tenantId:this.getcookie('storeId'),Token:'12345'};
                //异步请求
                this.$http.get(this.productURL+"/vueFeign/findDeviceList",{
                    params: params})
                    .then(response => {
                        if (response.status === 200) {
                            if(response.body.Code=='200'){
                                this.kioskList = response.body.Data;
                            }else if(response.body.code=='500'){
                                this.$message({ showClose: true, message: response.body.msg,  type: 'error' });
                            }
                        }
                        this.getData();
                    },function(response){
                        this.loading = false;
                        this.$message({
                            showClose: true,
                            message: '网络异常',
                            type: 'error'

                        });
                    })
            },
        }

    }

</script>
<style>
    .demo-table-expand {
        font-size: 0;
    }
    .demo-table-expand label {
        width: 90px;
        color: #99a9bf;
    }
    .demo-table-expand .el-form-item {
        margin-right: 0;
        margin-bottom: 0;
        width: 50%;
    }
    .customWidth {
        width: 60%;
    }
    .box_relative{
        float: left;
    }
</style>


// WEBPACK FOOTER //
// appletOrderManager.vue?17835772